import { WarehouseTypes, } from './projects';
export const MULTI_CONNECTION_WAREHOUSE_TYPES = [
    WarehouseTypes.POSTGRES,
    WarehouseTypes.ATHENA,
    WarehouseTypes.SNOWFLAKE,
];
export const supportsMultipleConnections = (warehouseType) => warehouseType !== null &&
    MULTI_CONNECTION_WAREHOUSE_TYPES.includes(warehouseType);
const DATABASE_LISTING_WAREHOUSE_TYPES = [
    WarehouseTypes.POSTGRES,
    WarehouseTypes.ATHENA,
];
export const supportsConnectionDatabaseListing = (warehouseType) => DATABASE_LISTING_WAREHOUSE_TYPES.includes(warehouseType);
export const WAREHOUSE_CONNECTION_NAME_MAX_LENGTH = 100;
export const WAREHOUSE_CONNECTION_NAME_CONFLICT_MESSAGE = 'A connection with this name already exists in this project.';
export const validateWarehouseConnectionName = (name) => {
    const trimmedName = name.trim();
    if (trimmedName.length === 0)
        return 'Enter a name';
    if (trimmedName.length > WAREHOUSE_CONNECTION_NAME_MAX_LENGTH) {
        return `Name must be ${WAREHOUSE_CONNECTION_NAME_MAX_LENGTH} characters or fewer`;
    }
    return null;
};
//# sourceMappingURL=warehouseConnections.js.map